<template src="./IntegrationComponent.template.html"></template>
<script>
  import foliomodal from "../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";

  export default {
    components: {
      foliomodal
    },
    name: "IntegrationPage",
    props: [""],
    data() {
      return {
        showPanel: false,
        showBEPanel: false,
        showApiPanel: false,
        showSMPanel: false,
        url: window.location.protocol + "//" + window.location.host,
        stripeUrl:
          "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_EbEZy2NBGahJqCQvfb7rRcMI0rkmL6gQ&scope=read_write",
        paymentAccountList: [],
        accountEdit: false,
        paymentAccountEdit: null,
        stripeAccount: {},
        isModalVisible: false,
        selectedRUProperty: {},
        selectedStatusId: 0,
        statusList: [
          {
            statusName: "Active",
            statusId: 1
          },
          {
            statusName: "Inactive",
            statusId: 0
          },
          {
            statusName: "Obsolete",
            statusId: -1
          },
          {
            statusName: "Remove Integration",
            statusId: -2
          }
        ],
        beStatusList: [
          {
            statusName: "Active",
            statusId: 1
          },
          {
            statusName: "Inactive",
            statusId: 2
          },

        ],
        IsActive: 1,
        IsLive: null,
        beList: [],
        BeIsActive: 1,
        apiUserDetailList: [],
        syncSettings: null,
        integrationChannels: {
          CrsName: "Rentals United",
          IsUnitMapped: true
        },
        listOfIntegrations: [],
        integrationName: null,
        headerColumnList: {
          TEMPO: { Label: "TEMPO", IsChecked: true, ColumnName: "TEMPO" },
          RENTALSUNITED: {
            Label: "RENTALSUNITED",
            IsChecked: true,
            ColumnName: "RENTALS UNITED"
          },
          CHANNELS: {
            Label: "CHANNELS",
            IsChecked: true,
            ColumnName: "CHANNELS"
          },
          STATUS: { Label: "STATUS", IsChecked: true, ColumnName: "STATUS" }
        },
        RUPropertyStatusList: [
          {
            statusName: "Pull data",
            statusId: 1
          },
          {
            statusName: "Push data",
            statusId: 2
          },
          {
            statusName: "Activate",
            statusId: 3
          },
          {
            statusName: "InActivate",
            statusId: 4
          },
          {
            statusName: "Create Unit",
            statusId: 5
          },
          {
            statusName: "Push Inventory, Rates, Restrictions",
            statusId: 6
          }
        ],
        viewOptionsList: [
          {
            optionName: "All",
            isChecked: true
          },
          {
            optionName: "Active",
            isChecked: false
          },
          {
            optionName: "Inactive",
            isChecked: false
          },
          {
            optionName: "Create Unit",
            isChecked: false
          },
          {
            optionName: "Create Property in RU",
            isChecked: false
          }
        ],
        modalParams: {},
        selectedFilter: "All",
        isFilterOptionSelected: false,
        RU_PropertyDetailList: [],
        UnLinkedPropertyDetailList: [],
        RU_UserLoginList: [],
        showRUClientDetails: false,
        ruClientName: "",
        intigrationClientDetails: {},
        isEdit: false,
        searchText: "",
        UnlinkUnitList: [],
        TypeOfIntegration: { IsIntegrated: 0 },
        isNoResultDisplay: false,
        ruComponentDropdownOpen: false,
        showFinalyticAccountDetails : false,
        selectedIntegration : {},
        showSlimCdAccountDetails :  false,
        selectedPaymentAccount : {},
        isDropdownOpen: false,
        showQuickbookAccountDetails: false,
        showQBdetails: false,
        qbClientName: "",
        SyncUnitorunittype: 1
      };
    },
    methods: {
      Save_Integration_SyncunitorunittypeSettings(RUproperty, messageType) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_Integration_SyncunitorunittypeSettings",
          params: {
            CrsId:vm.intigrationClientDetails.CrsId,
            IntegrationId: vm.selectedIntegration.IntegrationId,
            UserName:vm.ruClientName,
            SyncUnitorunittype: vm.intigrationClientDetails.SyncUnitorunittype
          },
          callback: function (error, response) {

          }
        });
      },
      updateRUComponentDropdown(value) {
        var vm = this;
        vm.ruComponentDropdownOpen = value;
      },
      filterRUPropertyList(optionName) {
        var vm = this;
        vm.isFilterOptionSelected = true;
        vm.selectedFilter = optionName;
        //var selectedOptionList = vm.viewOptionsList.filter(function(option) {
        //  console.log(selectedOptionList)
        //  return option.isChecked == true;
        //});
        vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
        $("#viewOptionsList").removeClass("show");
      },
      clearSearchText(event) {
        var vm = this;
        vm.searchText = "";
        vm.isFilterOptionSelected = false;
        vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
        $(".dropdownMenuList").removeClass("show");
        event.stopPropagation();
      },
      getCrsPropertyListBySearchText(value) {
        let vm = this;
        if (((value.which <= 90 && value.which >= 48) || value.which == 8 || value.which == 46) && value.code != "MetaLeft") {
          clearTimeout(vm.timeout);
          vm.timeout = setTimeout(function () {
            vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
          }, 2000);
        }
      },
      editUnit(index) {
        var vm = this;
        var property = vm.RU_PropertyDetailList[index];
        property.isEdit = true;
        property.IsConnected = 0;
        vm.RU_PropertyDetailList.splice(index, 1, property);
      },
      PushDataToRU(RUproperty, messageType) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "syncUnitToRU",
          params: {
            UnitId: RUproperty.UnitId,
            CrsPropertyId: RUproperty.CrsPropertyId,
            MessageType: messageType,
            CrsId: 2,
            rentalUnitedClient: vm.RU_UserLoginList[0]
          },
          callback: function (error, response) {
            console.log("PushDataToRU response", response);
            if (messageType == "Property Sync") {
              if (error) {
                vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "Warning!",
                  message: `${vm.selectedRUProperty && vm.selectedRUProperty.TypeofUnit == 'UnitType' ? 'Unit type' : 'Unit'} sync failed`
                });
              } else {
                if (response && response.PropertyId != -1) {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: `${vm.selectedRUProperty && vm.selectedRUProperty.TypeofUnit == 'UnitType' ? 'Unit type' : 'Unit'} sync successful`
                  });

                  setTimeout(() => {
                    vm.$refs.RuIntegration.pullPropertyList(vm.RU_UserLoginList[0]);
                    vm.$refs.RuIntegration.getRentalUnitedClients()
                    vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
                  }, 20000);

                }
                else {
                  vm.$store.dispatch("toastr", {
                    type: "warning",
                    header: "warning!",
                    message: `${vm.selectedRUProperty && vm.selectedRUProperty.TypeofUnit == 'UnitType' ? 'Unit type' : 'Unit'} sync failed`
                  });
                }
              }
            }
            if (messageType == "Rates") {
              if (response && response.message == "Success") {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Rates sync successfull"
                });
              } else if (response && response.message) {
                vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "warning!",
                  message: "Rates sync failed " + response.message
                });
              }
            }
            if (messageType == "Inventory") {
              if (response && response.message == "Success") {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Inventory sync successfull"
                });
              } else if (response && response.message) {
                vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "warning!",
                  message: "Inventory sync failed " + response.message
                });
              }
            }
            if (messageType == "Restrictions") {
              if (response && response.message == "Success") {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Restrictions sync successfull"
                });
              } else if (response && response.message) {
                vm.$store.dispatch("toastr", {
                  type: "warning",
                  header: "warning!",
                  message: "Restrictions sync failed " + response.message
                });
              }
            }
          }
        });
      },
      PullData_RUSpecProp(RUproperty, statusId) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "PullData_RUSpecProp",
          params: {
            username: vm.RU_UserLoginList[0].UserName,
            password: vm.RU_UserLoginList[0].Password,
            propertyId: RUproperty.CrsPropertyId,
            UnitId: RUproperty.UnitId,
            CrsId: 2,
            isPullData: statusId == 1 ? true : false,
            createType: RUproperty.UnitSetId == 3 || (statusId == 7 && !RUproperty.UnitId) || (RUproperty.TypeofUnit == "UnitType" && RUproperty.UnitId) ? "UnitType" : "Unit",
          },
          callback: function (error, response) {
            if (error) {
              console.log("error PullData_RUSpecProp == ", error)
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Error!",
                header: "Unable to pull data from RU"
              });
              return
            }
            console.log("PullData_RUSpecProp response", response);
            vm.$store.dispatch("toastr", {
              type: "success",
              message: "Success!",
              header: "Pull data from RU is success"
            });
            vm.$refs.RuIntegration.pullPropertyList(vm.RU_UserLoginList[0]);
            vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
            if (statusId == 5 || statusId == 7) {
              // vm.$store.state.bus.$emit("pullRUSpecProp", response);
              response.rentalUnitedClient = vm.RU_UserLoginList[0]
              vm.$store.commit('setpullRUSpecProp', response);
              let propertyId = -1;
              let unitId = -99;
              let redirectDetail = statusId == 5 ? "unitDetail" : "unitTypeDetail";
              vm.$router.push("/"+redirectDetail+"/" + unitId + "/" + propertyId + "?crsPropertyId=" + RUproperty.CrsPropertyId);
            }
          }
        });
      },
      Save_CrsPropertyDetails(RUproperty) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_CrsPropertyDetails",
          params: {
            CrsId: 2,
            UnitId: RUproperty.UnitId,
            IsActive: true,
            PropertyId: RUproperty.CrsPropertyId,
            username: vm.RU_UserLoginList[0].UserName,
            Password: vm.RU_UserLoginList[0].Password,
            CrsResponse: null,
            MessageId: null,
            ruIntegarationscreen: true,
            ownerId: RUproperty.CrsOwnerId
          },
          callback: function (error, response) {
            console.log("Save_CrsPropertyDetails response", response);
            if (error) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to activate",
                header: "Error!"
              });
              return;
            }
            if (response[0] && response[0].length > 0 && response[0][0].ErrorMessage && response[0][0].ErrorMessage.trim() != "") {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to activate",
                header: "Error!"
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Success!",
                header: "Activated Successfully"
              });
            }
            vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
            vm.$refs.RuIntegration.pullPropertyList(vm.RU_UserLoginList[0]);
            vm.$refs.RuIntegration.getRentalUnitedClients()
            vm.Get_ListOfIntegrations()
          }
        });
      },
      deleteUnitSyncDetails(RUproperty) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "deleteUnitSyncDetails",
          params: {
            UnitId: RUproperty.UnitId,
            fromMapping: 1,
            rentalUnitedClient: vm.RU_UserLoginList[0],
            crsPropertyId: RUproperty.CrsPropertyId
          },
          callback: function (error, response) {
            console.log("deleteUnitSyncDetails response", response);
            if (error) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to InActivate",
                header: "Error!"
              });
              return;
            }
            if (response[0] && response[0].length > 0 && response[0][0].ErrorMessage) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to InActivate",
                header: "Error!"
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "InActivated Successfully",
                header: "Success!"
              });
              vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName)
              vm.$refs.RuIntegration.pullPropertyList(vm.RU_UserLoginList[0]);
              vm.$refs.RuIntegration.getRentalUnitedClients()
              vm.Get_ListOfIntegrations()
            }
          }
        });
      },
      updateProcess(event) {
        var vm = this;
        var RUproperty = vm.selectedRUProperty;
        var statusId = vm.selectedStatusId;
        if (statusId == 1) {
          console.log("Pull Data Action")
          vm.PullData_RUSpecProp(RUproperty, statusId);
        } else if (statusId == 2) {
          console.log("Push Data Action")
          vm.PushDataToRU(RUproperty, "Property Sync");
        } else if (statusId == 3) {
          console.log("Activate Action")
          vm.Save_CrsPropertyDetails(RUproperty)
        } else if (statusId == 4) {
          console.log("InActivate Action")
          vm.deleteUnitSyncDetails(RUproperty)
        } else if (statusId == 6) {
          console.log("Push Inventory, Rates, Restrictions Action");
          var ruSyncMethodsList = [];
          ruSyncMethodsList.push({ IsChecked: vm.RU_UserLoginList[0].SyncRates, method: 'Rates' });
          ruSyncMethodsList.push({ IsChecked: vm.RU_UserLoginList[0].SyncInventory, method: 'Inventory' });
          ruSyncMethodsList.push({ IsChecked: vm.RU_UserLoginList[0].SyncRestrictions, method: 'Restrictions' });
          vm.syncUnitDetailsToRU(ruSyncMethodsList, RUproperty);
        }
        vm.isModalVisible = false;
        vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
        $('.dropdown.open .dropdown-toggle').dropdown('toggle');
        if (event) {
          event.stopPropagation();
        }
      },
      syncUnitDetailsToRU(ruSyncMethodsList, RUproperty) {
        let vm = this;
        let ruSyncMethods = ruSyncMethodsList.filter(
          col => col.IsChecked == true
        );
        let syncMethods = ruSyncMethods.map(obj => obj.method);
        console.log("ruSyncMethods===>", syncMethods);
        for (let method of syncMethods) {
          vm.PushDataToRU(RUproperty, method);
        }
      },
      openPopup(RUproperty, statusId) {
        var vm = this;
        vm.selectedRUProperty = {};
        vm.selectedStatusId = 0;
        vm.selectedRUProperty = RUproperty;
        vm.selectedStatusId = statusId;

        vm.isModalVisible = true;

        var message = "";
        var title = "";
        switch (vm.selectedStatusId) {
          case 1:
            title = "Pull Data",
              message = "Do you want to pull the data?";
            break;
          case 2:
            title = "Push Data",
              message = "Do you want to push the data?";
            break;
          case 3:
            title = "Activate",
              message = "Do you want to Activate?";
            break;
          case 4:
            title = "Inactivate"
            message = "Do you want to Inactivate?";
            break;
          case 6:
            title = "Push Inventory, Rates, Restrictions",
              message = "Do you want to Sync/Push Inventory, Rates, Restrictions?";
            break;
        }

        vm.modalParams = {
          popupTitle: title,
          popupMessage: message,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.updateProcess,
          noButtonCallback: vm.closePopup
        };
      },
      closePopup(event) {
        let vm = this;
        vm.isModalVisible = false;
        vm.selectedRUProperty = {};
        vm.selectedStatusId = 0;
        vm.isDropdownOpen = false;
        if (event)
          event.stopPropagation();
      },
      update_Unit(event, RUproperty, statusId) {
        var vm = this;
        // event.stopPropagation();
        if (statusId == 5 || statusId == 7) {
          console.log("Create Unit Action")
          vm.PullData_RUSpecProp(RUproperty, statusId);
          vm.updateRUClientDetailList(vm.RU_UserLoginList[0].UserName);
          $('.dropdown.open .dropdown-toggle').dropdown('toggle');
        } else {
          vm.openPopup(RUproperty, statusId);
        }
      },
      updateRUClientDetailList(userName, searchValue, filterValue) {
        var vm = this;
        vm.selectedFilter = filterValue != undefined ? filterValue : vm.selectedFilter
        if (searchValue != undefined) {
          vm.searchText = searchValue
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetCrsPropertyList",
          params: {
            username: userName,
            SearchText: vm.searchText
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in GetCrsPropertyList => ", err);
              return;
            }
            if (response) {
              console.log("response in GetCrsPropertyList", response);
              var mergedResponse = [];
              vm.isNoResultDisplay = true;

              let crsPropertyList = response.recordsets[2]
              let unitList = response.recordsets[1]
              let userLoginList = response.recordsets[4]
              //if (vm.isFilterOptionSelected) {
              var list = [];

              if (vm.selectedFilter == "Active") {
                var activeList = crsPropertyList.filter(function (mapped) {
                  return mapped.IsConnected == 1;
                });
                list = list.concat(activeList);
                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
              } else if (vm.selectedFilter == "Inactive") {
                var inactiveList = crsPropertyList.filter(function (mapped) {
                  return mapped.IsConnected == 0 && mapped.UnitName != null;
                });
                list = list.concat(inactiveList);
                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
              } else if (vm.selectedFilter == "Create Unit") {
                var createUnitList = crsPropertyList.filter(function (mapped) {
                  return mapped.IsConnected == 0 && mapped.UnitName == null;
                });
                list = list.concat(createUnitList);
                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length);
              } else if (vm.selectedFilter == "Create Property in RU") {
                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...list);
                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
              } else if (vm.selectedFilter == "All") {
                vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...crsPropertyList);
                vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
              }
              //} else if (vm.selectedFilter == "All") {
              //  vm.RU_PropertyDetailList.splice(0, vm.RU_PropertyDetailList.length, ...crsPropertyList);
              //  vm.UnlinkUnitList.splice(0, vm.UnlinkUnitList.length, ...response.recordsets[5]);
              //}
              vm.UnLinkedPropertyDetailList.splice(0, vm.UnLinkedPropertyDetailList.length, ...unitList);
              vm.RU_UserLoginList.splice(0, vm.RU_UserLoginList.length, ...userLoginList);
            }
          }
        });
      },
      redirectToRentalsUnited(event, IsIntegrated,selectedIntegration) {
        var vm = this;
        vm.searchText = "";
        vm.selectedFilter = "All";
        if(IsIntegrated == 1){
        vm.isFilterOptionSelected = false;
        vm.showRUClientDetails = false;
        vm.showSidePanel(event, selectedIntegration.IntegrationName, IsIntegrated,selectedIntegration);
        }
        // else if(IsIntegrated == 9){
        //   vm.showQBdetails =  false
        //   vm.showSidePanel(event, "QuickBooks",IsIntegrated)
        // }
      },
      hideRentalsUnitedClientDetails() {
        var vm = this;
        vm.showRUClientDetails = false;
        vm.ruClientName = "";
      },
      showRentalsUnitedClientDetails(clientName,intigrationClientDetails) {
        var vm = this;
        vm.showRUClientDetails = true;
        vm.ruClientName = clientName;
        vm.intigrationClientDetails = intigrationClientDetails;
        vm.integrationName = "Rentals United";
      },
      redirectToDetailPage(BE_Id) {
        let vm = this;
        vm.$router.push("/bookingEngineDetail/" + BE_Id);
      },
      redirectToAPIDetailPage(apiUserId) {
        let vm = this;
        vm.$router.push("/openApiTokenDetail/" + apiUserId);
      },
      getBE_List() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "getBE_List",
          params: {
            ModuleAction: "getBE_List",
            IsActive: vm.BeIsActive
          },
          callback: function (err, response) {
            if (err) {
              console.log("Error in getBE_List => ", err);
              return;
            }
            if (response) {
              console.log("response in getBE_List", response);
              if (response[0]) {
                vm.beList = response[0];
              }

            }
          }
        });
      },
      getAccountDetails(e) {
        let vm = this;
        if (e.target.checked) {
          vm.IsActive = 1;
        } else {
          vm.IsActive = 0;
        }
        vm.Get_PaymentAccount_Details();
      },
      getBeDetail(e) {
        let vm = this;
        if (e.target.checked) {
          vm.BeIsActive = 1;
        } else {
          vm.BeIsActive = 2;
        }
        vm.getBE_List()
      },
      makePaymentAccountDefault(paymentAccount, event) {
        let vm = this;
        event.stopPropagation();
        let classsName = "#" + this.paymentAccountEdit;
        $(classsName).removeClass("show");
        // paymentAccount.IsDefault = true;
        vm.selectedPaymentAccount = paymentAccount;
        console.log("paymentAccount-mk--", paymentAccount, vm.selectedPaymentAccount);
        // vm.Save_Acc_Commission_Config({accountId: paymentAccount.PaymentAccountId,statusId: 1,IsDefault: 1});
        vm.isModalVisible = true;
        vm.modalParams = {
          popupTitle: `${paymentAccount.GatewayId === 1 ? 'Stripe' : 'Clearview Payment'}`,
          popupMessage: `Do you want to make Stripe Payments your Default payment processor?`,
          isRUPopup: true,
          yesButtontext: "Yes",
          noButtonText: "No",
          yesButtonCallback: vm.Update_Acc_Commission_Config,
          noButtonCallback: vm.closePopup
        }
        // vm.Update_Acc_Commission_Config(paymentAccount);
      },
      removePaymentAccount(paymentAccount, statusId) {
        let vm = this;
        let classsName = "#" + this.paymentAccountEdit;
        $(classsName).removeClass("show");
        // paymentAccount.IsDefault = false;
        paymentAccount.StatusId = statusId;
        // vm.Save_Acc_Commission_Config({accountId: paymentAccount.PaymentAccountId,statusId: paymentAccount.StatusId,IsDefault: paymentAccount.IsDefault});
        vm.Update_Acc_Commission_Config(paymentAccount);
      },
      Update_Acc_Commission_Config(paymentAccount) {
        let vm = this;
        if (vm.selectedPaymentAccount && vm.selectedPaymentAccount.GatewayId) {
          vm.selectedPaymentAccount.IsDefault = true
        }
        paymentAccount = paymentAccount.GatewayId ? paymentAccount : vm.selectedPaymentAccount;
        console.log("update---paymenttac----", paymentAccount, vm.selectedPaymentAccount, paymentAccount.IsDefault);

        vm.$store.dispatch("dataRequestHandler", {
          key: "Update_Acc_Commission_Config",
          params: {
            ModuleAction: "Update_Acc_Commission_Config",
            propertyId: null,
            unitId: null,
            isClient: false,
            paymentAccount: paymentAccount,
            CommissionPercent: 0,
            CommissionAmmount: null,
            IsLive: vm.IsLive == true ? 1 : 0
          },
          callback: function (err, response) {
            if (err) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Error!",
                header: "unable to update"
              });
              return;
            }
            if (response) {
              console.log("response in Update_Acc_Commission_Config", response);
              if (
                response[0] &&
                response[0].length > 0 &&
                response[0][0].ErrorMessage
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error!",
                  header: "unable to update"
                });
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "success",
                  message: "Updated the account successfully",

                });
                vm.Get_PaymentAccount_Details();
                vm.Get_ListOfIntegrations()
              }
            }
          }
        });
        vm.isModalVisible = false
      },
      removeBookingEngine(be, statusId) {
        let vm = this;
        console.log("be-statusId", be);
        // let bename = be.BE_Name;
        //  vm.BeIsActive = statusId;
        // vm.$store.state.bus.$emit('SaveBEDomainSettings', bename, statusId);

        vm.Update_BEStatus(statusId, be);
      },
      Update_BEStatus(StatusId, be) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Update_BEStatus",
          params: {
            ModuleAction: "Update_BEStatus",
            BE_Id: be.BE_Id,
            StatusId: StatusId,
          },

          callback: function (err, response) {


            if (err) {
              console.log("Error in Update_BEStatus => ", err);
              return;
            }

            if (response) {

              console.log("Save_BEDomainSettingsresponse", response);
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Updated the BookingEngine successfully",
                header: ""
              });

              vm.getBE_List()
              vm.Get_ListOfIntegrations()
            }


          }


        });

      },




      // Save_BEDomainSettings(StatusId, be) {
      //   let vm = this;
      //   vm.$store.dispatch("dataRequestHandler", {
      //     key: "Save_BEDomainSettings",
      //     params: {
      //       ModuleAction: "Save_BEDomainSettings",
      //       BE_Id: be.BE_Id,
      //       BE_Name: be.BE_Name,
      //       BE_Description: be.BE_Description,
      //       GACode: null,
      //       // DepositPercent: vm.beData.DepositPercent,
      //       GuestPattern: null,
      //       ChargesPattern: null,
      //       AccomodationPattern: null,
      //       TLD_Id: be.TLD_Id,
      //       SubDomainName: be.SubDomainName,
      //       StatusId: StatusId,
      //       IsCheckedleftConfig:null,
      //       IsCheckedrightConfig: null,
      //       sectionName: "DomainConfiguration",
      //       BE_Type: be.BE_Type,
      //       Header: null,
      //       Footer: null,
      //       LeftView: null,
      //       RightView: null,
      //       HeaderStyle: null,
      //       HeaderHeight: null,
      //       FooterHeight: null,
      //       BeCss: null,
      //       HeaderHeightStyle: null,
      //       FooterHeightStyle: null,
      //       ResStatusId: null,
      //       FooterStyle: null,
      //       LeftViewCSS: null,
      //       RightViewCSS: null,
      //       MaxZoomValue:null,
      //       MinZoomValue: null,
      //       TermsAndConditions: null
      //     },

      //     callback: function (err, response) {


      //       if (err) {
      //         console.log("Error in Save_BEDomainSettings => ", err);
      //         return;
      //       }

      //       if (response) {

      //        console.log("Save_BEDomainSettingsresponse",response);
      //        vm.$store.dispatch("toastr", {
      //         type: "success",
      //         message: "Updated the BookingEngine successfully",
      //         header: ""
      //       });

      //        vm.getBE_List()
      //       }


      //     }


      //   });

      // },
      showAccountEdit(index) {
        let vm = this;
        setTimeout(function () {
          vm.paymentAccountEdit = "accountEdit" + index;
          let classsName = "#" + vm.paymentAccountEdit;
          $(classsName).addClass("show");
        }, 10);
      },
      showSidePanel(e, integrationName, integration, selectedIntegration) {
        let vm = this;
        console.log("selectedIntegration--:--", selectedIntegration);
        e.stopPropagation();
        vm.integrationName = integrationName
        vm.showFinalyticAccountDetails = false,
        vm.TypeOfIntegration.IsIntegrated = integration;
        vm.selectedIntegration = selectedIntegration;
        vm.selectedIntegration.IntegrationName = integrationName
        vm.showSlimCdAccountDetails = false;
        vm.showQuickbookAccountDetails = false;
        if (integrationName == "Stripe Connect") {
          // vm.showPanel = true;
          // vm.showBEPanel = false;
          // vm.showApiPanel = false;
          // vm.showSMPanel = false;
          // vm.IsActive = 1;
          vm.Get_PaymentAccount_Details();
        }
        if (integrationName == "Booking Engine") {
          // vm.showPanel = false;
          // vm.showBEPanel = true;
          // vm.showApiPanel = false;
          // vm.showSMPanel = false;
          // vm.BeIsActive = 1;
          vm.getBE_List()
        }
        if (integrationName == "Open API") {
          // vm.showPanel = false;
          // vm.showBEPanel = false;
          // vm.showApiPanel = true;
          // vm.showSMPanel = false;
          vm.Get_APIUser_Details();
        }
        if (integrationName == "SiteMinder" || integrationName == "Rentals United") {
          // vm.showPanel = false;
          // vm.showBEPanel = false;
          // vm.showApiPanel = false;
          // vm.showSMPanel = true;
          vm.Get_Integration_SyncSettings();
        }

      },
      hideSidePanel() {
        let vm = this;
        vm.showPanel = false;
        vm.showBEPanel = false;
        vm.showApiPanel = false;
        vm.showSMPanel = false;
      },
      connectToStripe() {
        let vm = this;
        let stateObj = {
          url: window.location.protocol + "//" + window.location.host,
          SecretKey: vm.stripeAccount.SecretKey,
        };
        stateObj = JSON.stringify(stateObj);
        console.log(vm.stripeAccount);
        let hostname =
          window.location.hostname == "localhost"
            ? "192.168.1.222"
            : window.location.hostname;
        let apiUrl =
          window.location.protocol +
          "//" +
          hostname +
          (window.location.port ? ":1339" : "");
        let uriVal = apiUrl + "/getConnectAccountId";
        vm.stripeUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${vm.stripeAccount.GatewayClientId
          }&scope=read_write&redirect_uri=${uriVal}&state=${stateObj}`;
      },
      Save_Acc_Commission_Config(account) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_Acc_Commission_Config",
          params: {
            ModuleAction: "Save_Acc_Commission_Config",
            accountId: account.accountId,
            gateWayId: 1,
            stripeTestKey: vm.stripeAccount.SecretKey,
            statusId: account.statusId,
            IsDefault: account.IsDefault,
            paymentType: 'Stripe',
            siteId: null,
            apiKeyId: null
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in Save_Acc_Commission_Config", response);
              if (
                response[0] &&
                response[0].length > 0 &&
                response[0][0].ErrorMessage
              ) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error!",
                  header: "unable to create account"
                });
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "",
                  header: "Successfully created the account"
                });
                vm.Get_PaymentAccount_Details();
                vm.Get_ListOfIntegrations();
              }
            }
          }
        });
      },
      redirectUrl() {
        let vm = this;
        const queryStringObj = this.getQueryStringObj();
        if (queryStringObj) {
          window.location = window.location.href.split("?")[0];
          vm.showPanel = true;
          if (queryStringObj.code && queryStringObj.code != "null") {
            vm.Save_Acc_Commission_Config({
              accountId: queryStringObj.code,
              statusId: 1,
              IsDefault: 0
            });
          } else if (queryStringObj.error) {
            return;
          }
        }
      },
      getQueryStringObj() {
        var sPageURL = window.location.href.split("?")[1];
        if (sPageURL) {
          return sPageURL
            .split("&")
            .reduce((acc, queryParam, queryParamIndex) => {
              const queryParamArray = queryParam.split("=");
              acc[queryParamArray[0]] = queryParamArray[1];
              return acc;
            }, {});
        } else {
          return null;
        }
      },
      Get_PaymentAccount_Details() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_PaymentAccount_Details",
          params: {
            ModuleAction: "Get_PaymentAccount_Details",
            propertyId: null,
            unitId: null,
            isClient: false,
            IsActive: vm.IsActive
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in Get_PaymentAccount_Details", response);
              vm.stripeAccount = response[1][0];
              vm.IsLive = response[3][0].IsLive
              vm.connectToStripe();
              vm.paymentAccountList.splice(
                0,
                vm.paymentAccountList.length,
                ...response[2]
              );
              vm.paymentAccountList = vm.paymentAccountList.filter(data => data.GatewayId === 1)
              // console.log("paymentAccountList-----",vm.paymentAccountList);
              vm.redirectUrl();
            }
          }
        });
      },
      Get_APIUser_Details() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_APIUser_Details",
          params: {
            ModuleAction: "Get_APIUser_Details",
            userId: null
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in Get_APIUser_Details", response);
              vm.apiUserDetailList = response[0]
            }
          }
        });
      },
      Get_Integration_SyncSettings() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_Integration_SyncSettings",
          params: {
            ModuleAction: "Get_Integration_SyncSettings"
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in Get_Integration_SyncSettings", response);
              vm.syncSettings = response[0][0]
            }
          }
        });
      },
      Save_Integration_SyncSettings() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_Integration_SyncSettings",
          params: {
            ModuleAction: "Save_Integration_SyncSettings",
            syncSettings: vm.syncSettings
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in Save_Integration_SyncSettings", response);
              if (response && response[0] && response[0][0] && response[0][0].ErrorMessage) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error in saving sync settings",
                  header: "Error!"
                });
                return
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  message: "Saved successfully",
                  header: "Success"
                });
              }
            }
          }
        });
      },
      Get_ListOfIntegrations() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_ListOfIntegrations",
          params: {
            ModuleAction: "Get_ListOfIntegrations"
          },
          callback: function (err, response) {
            if (err) {
              return;
            } else {
              console.log("response in Get_ListOfIntegrations", response);
              vm.listOfIntegrations = response[0]
            }
          }
        });
      },
      activeClass(integrationName) {
        return this.integrationName === integrationName;
      },
      showFinalyticAccountPanel(event) {
        let vm = this;
        event.preventDefault();
        event.stopPropagation();
        // if(vm.integrationName == 'Finalytic'){
          vm.showFinalyticAccountDetails = true;
        //   vm.integrationName = "Finalytic";
        // }else{
        //   vm.showQuickbookAccountDetails = true
        //   vm.integrationName = "QuickBooks";
        // }
        
      },
      closeFinalyticAccoutPanel() {
        let vm = this;
        vm.showFinalyticAccountDetails = false
      },
      showSlimCdAccountPanel(event) {
        let vm = this;
        event.preventDefault();
        event.stopPropagation();
        vm.showSlimCdAccountDetails = true;
        vm.integrationName = "Clearview Payments";
      },
      closeSlimCdAccoutPanel() {
        let vm = this;
        vm.showSlimCdAccountDetails = false
      },
      showQuickBookAccountPanel(event) {
        let vm = this;
        event.preventDefault();
        event.stopPropagation();        
        vm.showQuickbookAccountDetails = true;
        vm.integrationName = "QuickBooks";
      },
      closeQuickBookAccoutPanel(){
        let vm = this;
        vm.showQuickbookAccountDetails = false
      },
      hideQuickbookDetails() {
        var vm = this;
        vm.showQuickbookAccountDetails = false;    
        vm.showQBdetails = false;     
      },
      showQuickbookClientDetails(clientName) {
        var vm = this;
        vm.showQBdetails = true;
        vm.qbClientName = clientName;
        vm.integrationName = "QuickBooks";
      },
    },
    computed: {      
      isIntegratedStatus(){
        return this.selectedIntegration && this.selectedIntegration.IsIntegrated ? this.selectedIntegration.IsIntegrated : null
      },
      componentIntegrationId(){
        return this.selectedIntegration && this.selectedIntegration.IntegrationId ? this.selectedIntegration.IntegrationId : 0
      }
    },
    mounted() {
      let vm = this;
      vm.searchText = "";
      vm.showRUClientDetails = false;
      vm.showQBdetails = false;
      vm.Get_PaymentAccount_Details();
      vm.getBE_List();
      vm.Get_APIUser_Details();
      vm.Get_Integration_SyncSettings();
      vm.Get_ListOfIntegrations();
      $(document).click(function (e) {
        if ($('.stripeAcount .dropdown-menu').hasClass('show')) {

        } else {
          let rupageval = vm.$refs.RuIntegration ? vm.$refs.RuIntegration.isModalVisible : false
          let rupageval1 = vm.$refs.RuIntegration ? vm.$refs.RuIntegration.isMappingModalVisible : false
          let wheelHouseVal = vm.$refs.Wheelhouse ? vm.$refs.Wheelhouse.openWheelHouseComponent : false

          if (vm.showRUClientDetails == false && rupageval == false && wheelHouseVal == false && rupageval1 == false
            && vm.ruComponentDropdownOpen == false) {
            let classsName = "#" + vm.paymentAccountEdit;
            $(classsName).removeClass("show");
            vm.integrationName = null;
          }
          vm.ruComponentDropdownOpen = false;
          vm.isDropdownOpen = vm.isDropdownOpen ? false : vm.isDropdownOpen;
        }
      });
    },
    watch: {}
  };
</script>